<!-- <cigna-nx-welcome></cigna-nx-welcome> -->
<router-outlet *ngIf="!isShowErrMessage"> </router-outlet>

<div *ngIf="isApploading">Loading...</div>

<cigna-app-error *ngIf="isShowErrMessage"></cigna-app-error>
